<template>
  <div class="px-4 py-4">
    <div class="text-subtitle-1 font-weight-bold mb-2">
      {{ title }}
    </div>

    <v-row>
      <v-col cols="4">
        <div class="text-caption text-medium-emphasis">
          Emitidos
        </div>
        <div class="text-h6">
          {{ block.generated }}
        </div>
      </v-col>
      <v-col cols="4">
        <div class="text-caption text-medium-emphasis">
          Computados
        </div>
        <div class="text-h6">
          {{ block.read }}
        </div>
      </v-col>
      <v-col cols="4">
        <div class="text-caption text-medium-emphasis">
          Taxa de acesso
        </div>
        <div class="text-h6" :class="`text-${accessRateColor(block.access_rate)}`">
          {{ Math.round(block.access_rate) }}%
        </div>
      </v-col>
    </v-row>

    <v-divider v-if="block.rows.length > 0" class="my-2" />

    <v-table v-if="block.rows.length > 0" density="compact" class="mt-2">
      <thead>
        <tr class="bg-grey-lighten-4">
          <th>Tipo</th>
          <th>Emitidos</th>
          <th>Computados</th>
          <th>Taxa de acesso</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in block.rows" :key="row.ticket_type_name">
          <td class="font-weight-bold">
            {{ row.ticket_type_name }}
          </td>
          <td>{{ row.generated }}</td>
          <td>{{ row.read }}</td>
          <td :class="`text-${accessRateColor(row.access_rate)} font-weight-bold`">
            {{ Math.round(row.access_rate) }}%
          </td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script lang="ts" setup>
import { accessRateColor } from '@/components/TAccessRateGauge.vue'
import type { AccessControlBlock } from '@/types/AccessControl'

interface Props {
  title: string
  block: AccessControlBlock
}

defineProps<Props>()
</script>
